import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function CfgEarleyInitialize() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Initialize:</div>
        <div className='middle-rule-part'>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[A -> •α, i, i]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>A -> α ∈ P, </span>
            <span className={'unbreakable'}>i in [0...n]</span></div>
    </div>)
}
